import mutations from './medicationSelectSingle.mutations'
import actions from './medicationSelectSingle.actions'
import getters from './medicationSelectSingle.getters'

import initialState from './defaultState'

const state = initialState();

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}
